import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={117.991}
      height={124.883}
      viewBox="0 0 117.991 124.883"
      {...props}
    >
      <g data-name="Group 694">
        <g data-name="Component 8 \u2013 4">
          <path
            d="M116.978 24.995a24.751 24.751 0 01-11.441 21.644 10.547 10.547 0 00-5.06 8.855v3.273h-16.5v-3.273a10.582 10.582 0 00-5.088-8.883 24.751 24.751 0 0114.108-45.6 25.046 25.046 0 0123.981 23.984z"
            fill="#ffdc00"
            stroke="#000"
            strokeWidth={2}
          />
          <path
            data-name="Shape"
            d="M93.001 1.013a25.052 25.052 0 00-4.983.358 25.065 25.065 0 0120.714 23.624 24.751 24.751 0 01-11.44 21.643 10.547 10.547 0 00-5.06 8.855v3.273h8.251v-3.272a10.547 10.547 0 015.06-8.855 24.751 24.751 0 0011.44-21.644A25.046 25.046 0 0093.001 1.013z"
            fill="#fec108"
          />
          <path
            d="M82.805 58.911h18.856a1.15 1.15 0 011.15 1.15v8.983a1.15 1.15 0 01-1.15 1.15H82.805a1.15 1.15 0 01-1.15-1.15v-8.983a1.15 1.15 0 011.15-1.15z"
            fill="#165a9f"
            stroke="#000"
          />
          <path
            data-name="Shape"
            d="M100.48 69.767v2.75a8.251 8.251 0 01-16.5 0v-2.75z"
            fill="#003586"
            stroke="#000"
          />
          <path
            data-name="Shape"
            d="M78.477 28.515a2.75 2.75 0 01-2.75-2.751 16.517 16.517 0 0116.5-16.5 2.75 2.75 0 110 5.5 11 11 0 00-11 11 2.75 2.75 0 01-2.75 2.751z"
            fill="#f5f5f5"
          />
        </g>
        <g transform="translate(0 36.65)">
          <path
            data-name="Path 1056"
            d="M85.666 6.049a2.93 2.93 0 00-4.006-.562s.6-2.545-1.015-3.711c-1.466-1.06-4.4.943-4.4.943s-2.3-1.532-3.83-1.06.249 4.39.249 4.39l6.519 8.871 3.966.611c3.135-1.15.871-4.9.871-4.9s3.159-2.739 1.646-4.582z"
            fill="#c12929"
          />
          <path
            data-name="Path 1057"
            d="M28.625 63.306v7.891a1.467 1.467 0 00.878 1.343l4.77 2.091a1.47 1.47 0 001.051.048l5.732-1.908-4.4-8z"
            fill="#f4c59c"
          />
          <path
            data-name="Path 1058"
            d="M77.524 19.294h-1.246c-2.959 0-5.537 3.743-5.724 6.861 0 .528.006.869.006.869s8.481-1.874 7.155-7.669l-.191-.062z"
            fill="#c12929"
          />
          <path
            data-name="Path 1059"
            d="M29.503 72.541a1.466 1.466 0 01-.878-1.343l-3.698 15.569h5.865l3.481-12.136z"
            fill="#edbf36"
          />
          <path
            data-name="Path 1060"
            d="M80.646 15.026c-.858-.079-2.933 4.327-2.933 4.327l8.8 1.528s1.323-5.188-5.867-5.855z"
            fill="#edbf36"
          />
          <path
            data-name="Path 1061"
            d="M17.966 85.46c4.859-3.216 4.123-9.745-.886-12.331-3.814-1.97-15.614.165-15.614 5.89 0 6.237 12.248 9.253 16.5 6.441z"
            fill="#f4c69d"
          />
          <path
            data-name="Path 1062"
            d="M58.204 13.908c-.667 1.694-.969 3.522-1.74 5.17-3.6 7.685-17.538 16.778-25.512 16.7a6.005 6.005 0 01-5.828-4.8c-.177-1.135-3.034-8.954-5.167-11.488-3.594-4.265-7.723-4.639-12.855-5.277a5 5 0 00-5.246 2.8 4.774 4.774 0 00-.3 2.821l1.513 6.808.01.025a11.66 11.66 0 003.187 15.357 6.473 6.473 0 00.959 6.211 7.458 7.458 0 005.977 3.4 11.729 11.729 0 004.689 9.328 26.943 26.943 0 006.191 3.349c1.977.795 9.806.957 11.3 2.623 1.607 1.8 2.682 4.148 4.818 5.418a8.72 8.72 0 002.743.979 34.879 34.879 0 006.914.239c2.468 0 4.041-2.7 5.412-4.355 1.289-1.551 3.254-3.628 5.157-4.452 8.232-3.564 10.562-9.865 11.736-19.339.565-4.545-1.177-14.051-1.6-18.4-.314-3.239 2.479-7.729 5.72-7.729h1.435l2.933-4.267c0-11.732-18.047-12.28-22.441-1.12z"
            fill="#f4cdab"
          />
          <path
            data-name="Path 1063"
            d="M43.988 73.57l2.933 13.2h5.867l-2.935-13.2z"
            fill="#edbf36"
          />
          <path
            data-name="Path 1064"
            d="M72.156 41.276C70.981 50.75 68.65 57.05 60.419 60.615c-1.9.824-3.868 2.9-5.157 4.452-1.371 1.651-2.944 4.355-5.412 4.355a34.879 34.879 0 01-6.914-.239 8.756 8.756 0 01-2.742-.983c-2.135-1.27-3.211-3.622-4.818-5.418-1.49-1.666-9.318-1.828-11.3-2.623a26.944 26.944 0 01-6.191-3.349 11.729 11.729 0 01-4.689-9.328 7.456 7.456 0 01-5.977-3.4 7.854 7.854 0 01-1-1.922 6.452 6.452 0 001 6.072 7.458 7.458 0 005.977 3.4 11.729 11.729 0 004.689 9.328 26.943 26.943 0 006.191 3.349c1.977.795 9.806.957 11.3 2.623 1.607 1.8 2.682 4.148 4.818 5.418a8.72 8.72 0 002.743.979 34.879 34.879 0 006.914.239c2.468 0 4.041-2.7 5.412-4.355 1.289-1.551 3.254-3.628 5.157-4.452C68.651 61.2 70.981 54.9 72.156 45.426a25.48 25.48 0 00.028-4.468c-.011.104-.018.218-.028.318z"
            fill="#f4c59c"
          />
          <path
            data-name="Path 1065"
            d="M17.966 81.31c-3.724 2.465-13.591.45-15.972-4.284a4.066 4.066 0 00-.528 1.993c0 6.237 12.248 9.254 16.5 6.441a6.825 6.825 0 002.944-7.891 7.177 7.177 0 01-2.944 3.741z"
            fill="#f4b175"
          />
          <circle
            data-name="Ellipse 8"
            cx={1.88}
            cy={1.88}
            transform="translate(71.021 10.626)"
            r={1.88}
          />
          <path
            data-name="Path 1066"
            d="M20.233 49.584l-2.345-1.761a5.911 5.911 0 01-2.346 1.861l1.174 2.688a8.854 8.854 0 003.517-2.788z"
          />
          <path
            data-name="Path 1067"
            d="M85.744 15.249a3.669 3.669 0 00.308-.642 5.391 5.391 0 00-.262-3.669c1.368-1.521 2.6-3.88 1.01-5.82a4.215 4.215 0 00-3.635-1.643A4.267 4.267 0 0081.5.588c-1.685-1.22-4.007-.274-5.279.425a5.956 5.956 0 00-4.246-.757 2.245 2.245 0 00-1.4 1.248 4.7 4.7 0 00-.032 2.921c-5.326.014-11.299 2.85-13.703 8.95-.315.8-.55 1.613-.777 2.4a18.459 18.459 0 01-.925 2.688c-3.349 7.155-16.584 15.858-24.079 15.858h-.092a4.538 4.538 0 01-4.394-3.557c-.208-1.327-3.126-9.394-5.494-12.205-3.84-4.56-8.211-5.1-13.273-5.723l-.523-.065A6.447 6.447 0 00.51 16.448a6.221 6.221 0 00-.381 3.718l1.4 6.292A13.125 13.125 0 004.6 42.567a7.856 7.856 0 001.421 6.508 9.229 9.229 0 005.792 3.884 13.26 13.26 0 005.2 9.176 28.023 28.023 0 006.519 3.54 17.3 17.3 0 003.626.726v4.629l-3.66 15.4a1.464 1.464 0 001.428 1.8H39.59V85.3h-6.852l2.628-9.161a2.891 2.891 0 00.421-.069l5.233-1.742a12.646 12.646 0 001.625.438c.037.007.073.007.111.015l2.733 12.3a1.468 1.468 0 001.433 1.15h13.2V85.3h-6.16l-2.356-10.607c1.806-.7 3.1-2.368 4.1-3.674.235-.306.46-.6.682-.868A14.649 14.649 0 0161 66.107c8.858-3.836 11.392-10.689 12.609-20.5.433-3.484-.377-9.44-1.028-14.227a222.837 222.837 0 01-.431-3.289c1.708-.567 4.689-1.85 6.207-4.248a6.038 6.038 0 00.912-2.726l6.991 1.214a1.464 1.464 0 001.672-1.081 5.988 5.988 0 00-.9-4.692 5.892 5.892 0 00-1.29-1.306zM75.427 3.939a1.468 1.468 0 001.636-.006 4.468 4.468 0 012.723-.969c.654.474.537 1.779.446 2.189a1.46 1.46 0 00.6 1.534 1.48 1.48 0 001.658.007 1.406 1.406 0 012.04.286c.346.422-.642 1.811-1.475 2.54a1.472 1.472 0 00-.3 1.861 3.469 3.469 0 01.526 2.257.684.684 0 01-.273.328 12.118 12.118 0 00-1-.226c-.493-4.52-3.548-7.852-8.277-8.943a8.29 8.29 0 01-.466-1.751 5.961 5.961 0 012.162.893zM26.783 85.3l2.657-11.186 3.069 1.345-2.823 9.842zm8.078-12.012l-4.768-2.091v-4.388c1.784.276 3.746.655 4.191 1.1a22.145 22.145 0 011.4 1.817 19.782 19.782 0 002.122 2.581zM48.1 85.3l-2.277-10.233c.213 0 .425.021.636.021.587 0 1.169-.013 1.745-.028l.477-.007 2.279 10.248zm22.6-40.057c-1.119 9.015-3.255 14.878-10.865 18.174a16.892 16.892 0 00-5.7 4.861c-.243.293-.493.617-.752.955-1.032 1.345-2.2 2.871-3.531 2.871-.566 0-1.139.013-1.713.026a22.459 22.459 0 01-4.908-.236 7.222 7.222 0 01-2.287-.8 10.534 10.534 0 01-2.877-3.078 24.657 24.657 0 00-1.6-2.057c-1.2-1.345-4-1.806-8.136-2.358a24.412 24.412 0 01-3.705-.648 25.251 25.251 0 01-5.858-3.161 10.32 10.32 0 01-4-6.833 8.7 8.7 0 001.95-.584l-1.174-2.689a5.822 5.822 0 01-2.289.487 5.906 5.906 0 01-4.828-2.777 4.987 4.987 0 01-.927-4.363l2.521-3.78-2.44-1.626-1.526 2.29a10.24 10.24 0 012.636-16.566 10.321 10.321 0 015.144-1.021l.176-2.927A13.234 13.234 0 007.4 20.717l.644 1.317-.644-1.317a13.265 13.265 0 00-3.57 2.588L3 19.553a3.289 3.289 0 01.2-1.955 3.51 3.51 0 013.721-1.923l.525.065c4.812.592 8.289 1.022 11.389 4.7 1.887 2.24 4.654 9.679 4.84 10.771a7.473 7.473 0 007.262 6.035h.109c8.515 0 22.965-9.466 26.746-17.548a20.79 20.79 0 001.087-3.123c.218-.752.424-1.463.691-2.138 2.235-5.677 8.418-7.8 13.094-6.908 3.806.721 6.154 3.221 6.456 6.73a13.955 13.955 0 00-2.295 3.562h-.548a6.357 6.357 0 00-4.619 2.3 9.685 9.685 0 00-2.558 7.04c.117 1.213.336 2.82.579 4.608.594 4.377 1.408 10.368 1.023 13.473zm1.585-20.337a7.4 7.4 0 011.543-2.8 3.514 3.514 0 012.449-1.342h.087a3.154 3.154 0 01-.481 1.506 7.929 7.929 0 01-3.597 2.636zm7.639-6.655A13.987 13.987 0 0181 16.541a5.166 5.166 0 013.616 1.676 2.722 2.722 0 01.427.921z"
          />
          <path
            data-name="Path 1068"
            d="M56.019 28.934c-1.691 3.428-5.349 9.05-7.974 9.541a3.031 3.031 0 01-.182.029 12.527 12.527 0 011.692-3.847l-2.479-1.566c-1.187 1.885-2.994 5.339-1.687 7.261a2.578 2.578 0 002.279 1.1 5 5 0 00.919-.092c4.909-.919 9.55-10.085 10.063-11.127z"
          />
          <path
            data-name="Path 1069"
            d="M60.671 39.886a3.222 3.222 0 01-1.072.067 3.006 3.006 0 01.292-1.022l-1.311-.658-1.307-.663c-.214.419-1.221 2.594-.053 4.154a3.1 3.1 0 002.653 1.142 7.35 7.35 0 001.337-.135 15.3 15.3 0 007.4-3.44l-2.03-2.114a12.6 12.6 0 01-5.909 2.669z"
          />
          <path
            data-name="Path 1070"
            d="M0 79.019c0 2.7 1.754 5.136 4.94 6.849a19.074 19.074 0 008.56 2.122 9.634 9.634 0 005.27-1.306 8.323 8.323 0 003.93-7.488 8.854 8.854 0 00-4.95-7.369c-3.2-1.651-10.034-.891-14.061 1.559C1.276 74.855 0 76.803 0 79.019zm5.216-3.129a16.428 16.428 0 017.952-2.022 7.513 7.513 0 013.232.568 5.949 5.949 0 013.367 4.921 5.462 5.462 0 01-2.613 4.879c-2.123 1.4-7.284.95-10.827-.953-1.267-.682-3.394-2.142-3.394-4.267 0-1.154.768-2.207 2.283-3.129z"
          />
          <path
            data-name="Path 1071"
            d="M4.917 69.62a14.423 14.423 0 017.721-2.393l-.05-2.933a17.369 17.369 0 00-9.287 2.878l-1.176.777 1.617 2.447z"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
